import angular from 'angular';

export default ['$scope', 'api', function($scope, api) {
    var $ctrl = this;
    
    $ctrl.$onInit = function() {
        $scope.params = {NPI: $ctrl.npis[0].npi};
    };
}];